import { useCollectionPager } from 'framework/ViewTypes/hooks';
import { POSITION_FILL_REQUESTS_PAGE_SIZE, POSITION_FILL_REQUEST_STATUS } from '../constants';
import type { CollectionViewParamsConfig } from 'framework/ViewTypes';
import { FilterCondition } from 'framework/types';
import type { PositionFillRequestListItem, PositionFillRequestsFilters } from '../types';
import usePositionFillRequestsService from '../usePositionFillRequestsService';
import { buildFilter } from './filterState';

const VIEW_PARAMS_CONFIG: CollectionViewParamsConfig<PositionFillRequestsFilters> = {
  cache: true,
  filterRules: {
    status: { condition: FilterCondition.IN, values: Object.values(POSITION_FILL_REQUEST_STATUS) },
    ownerAlias: { condition: FilterCondition.EQ },
    'positionSlot.businessFunctionId': { condition: FilterCondition.IN },
  },
  sortableColumns: ['id', 'request', 'businessFunction', 'workRateType', 'category', 'status', 'ownerAlias'],
};

const usePositionFillRequestsCollection = () => {
  const { search } = usePositionFillRequestsService();

  return useCollectionPager<PositionFillRequestListItem, PositionFillRequestsFilters>({
    pageSize: POSITION_FILL_REQUESTS_PAGE_SIZE,
    viewParamsConfig: VIEW_PARAMS_CONFIG,
    fetchPage: ({ pageNumber, pageSize, filters, searchValue, sort, signal }) =>
      search(
        {
          pageNumber,
          pageSize,
          filter: buildFilter(searchValue, filters),
          sort,
        },
        { signal },
      ),
  });
};

export default usePositionFillRequestsCollection;
